import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { TabPanel } from "../../components/settings/TabPanel";
import BackgroundJobsPage from "./BackgroundJobsPage";
import FreeSamplesPage from "./FreeSamplesPage";
import HelpArticlesPage from "./HelpArticlesPage";
import LicenseAgreementsPage from "./LicenseAgreementsPage";
import Translate from "../../utils/Translate";
import { getQueryParam } from "../../utils/uriHelper";

export default function AdminPage() {
  const [value, setValue] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const tabParamValue = getQueryParam("tab");
    if (tabParamValue) {
      setValue(parseInt(tabParamValue));
    } else {
      setValue(0);
      navigate(`${location.pathname}?tab=0`, { replace: true });
    }
  }, [navigate, location]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(`${location.pathname}?tab=${newValue}`, { replace: true });
  };

  const tabs = [
    {
      label: Translate.get("BackgroundJobs"),
      component: <BackgroundJobsPage />,
      isVisible: true,
    },
    {
      label: Translate.get("AdminFreeSamplesTitle"),
      component: <FreeSamplesPage />,
      isVisible: true,
    },
    {
      label: Translate.get("AdminHelpArticlesTitle"),
      component: <HelpArticlesPage />,
      isVisible: true,
    },
    {
      label: Translate.get("AdminLicenseAgreementsTitle"),
      component: <LicenseAgreementsPage />,
      isVisible: true,
    },
  ];

  return (
    <div>
      <h2>{Translate.get("AdminPageTitle")}</h2>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={value} onChange={handleChange} centered>
            {tabs
              .filter((t) => t.isVisible)
              .map((t) => (
                <Tab className="tabFixFlow" label={t.label} key={"tab-" + t.label} />
              ))}
          </Tabs>
        </Box>
        {tabs
          .filter((t) => t.isVisible)
          .map((t, i) => (
            <TabPanel className="tabPanelNoPadding" value={value} index={i} key={"tab-panel-" + i}>
              {t.component}
            </TabPanel>
          ))}
      </Box>
    </div>
  );
}
